<template>
  <div class="page-wrapper">
    <van-nav-bar
      class="nav"
      fixed
      placeholder
      title="工具"
    />
    <div class="page-content">
      <div class="guide-menu">
        <template v-for="(item, i) in applets">
          <div
            :key="i"
            :class="['menu-item', item.vipsNeeded && item.vipsNeeded.length ? 'menu-item-vip' : '']"
            @click="handleSelect(item)"
          >
            <div class="text">{{ item.name }}</div>
            <div class="icon" :style="{ backgroundImage: 'url(' + item.icon + ')' }" />
          </div>
        </template>
      </div>
    </div>
    <!--  -->
    <van-popup
      v-model="show"
      position="bottom"
      closeable
      :style="{ height: '100%' }"
    >
      <div class="popup-content" :style="{ background: 'url(' + currentApplet.cover + ') center no-repeat' }">
        <div v-if="currentApplet.locked" class="footer">
          <div class="title">
            <span>开通工具权限</span>
          </div>
          <div class="actions">
            <template>
              <van-button
                plain
                color="#FCB959"
                class="action-btn left"
                block
                @click="payHandler('applets', currentApplet)"
              >
                ¥<span v-money="currentApplet.cashNeeded" />单次试用
              </van-button>
              <van-button
                v-if="currentApplet && currentApplet.vipsNeeded && currentApplet.vipsNeeded.length"
                color="linear-gradient(to right, #EDAE6D, #F8CF89)"
                class="action-btn right"
                block
                @click="payHandler('vips', currentApplet.vipsNeeded[0])"
              >
                ¥<span v-money="currentApplet.vipsNeeded[0].cashNeeded" />开通VIP无限次
              </van-button>
            </template>
          </div>
        </div>
        <div v-else class="footer">
          <div class="title">打开工具</div>
          <div class="actions">
            <template v-if="currentApplet.platform === 'h5'">
              <van-button
                plain
                color="#FCB959"
                class="action-btn"
                block
                @click="leaveToApplet"
              >
                打开工具
              </van-button>
            </template>
            <template v-else-if="currentApplet.platform === 'miniprogram'">
              <wx-weapp-item :username="currentApplet.miniprogramAppid" :path="currentApplet.miniprogramPath" weapp-name="前往小程序">
                <van-button
                  slot="button"
                  plain
                  color="#FCB959"
                  class="action-btn"
                  block
                  @click="leaveToApplet"
                >
                  前往小程序
                </van-button>
              </wx-weapp-item>
            </template>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="overlay-wrapper">
      <wx-pay-overlay
        :overlay-status.sync="showWxPayOverlay"
        :qrcode="wxPayQrcode"
        @successed="$router.push({name: 'orders'})"
      />
    </div>
  </div>
</template>

<script>
import { isWechatBrowser, onBridgeReady } from '@/utils/wechat'
import { wxPayENV } from '@/config/wx.config'
import { WxWeappItem } from '@/components/item'
import WxPayOverlay from '@/components/wx'
import { Applet, Orders } from '@/api'

export default {
  name: 'Tools',
  components: { WxWeappItem, WxPayOverlay },
  data () {
    return {
      show: false,
      applets: [],
      currentApplet: {},
      showWxPayOverlay: false,
      wxPayQrcode: ''
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const { applets } = await Applet.list()
      this.applets = applets
    },
    async handleSelect (data) {
      this.currentApplet = data
      this.show = true
    },
    async payHandler (collection, data) {
      try {
        const { order } = await Orders.add({
          collection,
          resourceId: data.id,
          data
        })
        const { wxPayPayload, wxPayQrcode, wxPayUrl } = await Orders.pay({
          id: order.id,
          payType: 'cash'
        })

        switch (isWechatBrowser()) {
          case true:
            // 微信浏览器
            onBridgeReady(wxPayPayload).then(async () => {
              this.$notify({ type: 'success', message: '支付成功' })
              const { applet } = await Applet.detail(this.currentApplet.id)
              this.currentApplet = applet
            }).catch(() => {
              this.$notify({ type: 'danger', message: '支付失败' })
            })
            break
          case false:
            // 普通浏览器
            this.show = false
            this.showWxPayOverlay = true
            if (wxPayENV === 'NATIVE') {
              this.wxPayQrcode = wxPayQrcode
            } else {
              window.location = wxPayUrl
            }
            break
        }
      } catch (error) {
        console.log(error)
      }
    },
    async leaveToApplet () {
      const { id, platform, h5Link } = this.currentApplet
      if (platform === 'h5') {
        const url = window.location.href
        try {
          const { accessToken } = await Applet.accesstoken(id)
          window.location = `${h5Link}?access_token=${accessToken}&redirect_url=${url}`
        } catch ({ message = '获取Token失败' }) {
          this.$notify({ type: 'danger', message })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: #FFFFFF;
  height: 100%;
  .nav {
    ::v-deep {
      .van-nav-bar__title {
        @include sc($font-size-xlg, $color-text-heavy);
      }
    }
  }
  .page-content {
    padding: 20px;
    .guide-menu {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 20px;
      .menu-item {
        height: 72px;
        padding: 9px 12px;
        background-color: rgba($color: #D8D8D8, $alpha: .1);
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        &-vip {
          position: relative;
          @include bg-image-png('/tools/vip-bg');
          background-size: cover;
          &::before {
            content: 'VIP';
            position: absolute;
            left: 0;
            top: 0;
            width: 57px;
            height: 17px;
            padding: 0 10px;
            border-radius: 8px 0 8px 0;
            background: linear-gradient(to right, #FBE1B5, #E3A629);
            text-align: right;
            @include ft(12px, 17px);
            font-weight: 500;
            color: #FFF;
          }
          &::after {
            content: '';
            position: absolute;
            left: 2px;
            top: -10px;
            width: 28px;
            height: 34px;
            @include bg-image-png('/vip/medal-active');
            background-size: contain;
            transform: rotate(-30deg);
          }
        }
        .text {
          color: #000000;
          @include ft(14px, 20px);
          @include ellipsis(2, 20px);
          overflow: hidden;
        }
        .icon {
          flex: 0 0 60px;
          @include wh(53px, 53px);
          border-radius: 50%;
          overflow: hidden;
          @include bg-image-fit();
        }
        &:active {
          opacity: .8;
        }
      }
    }
  }
  .popup-content {
    position: relative;
    background-color: #FFFFFF;
    width: 100%;
    height: 100%;
    @include bg-image-png('/tools/popup-bg');
    background-size: contain;
    .footer {
      padding: 0 20px 10px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      border: 16px 16px 0 0;
      background-color: #FFFFFF;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .title {
        margin-bottom: 10px;
        color: $color-text-medium;
        @include ft(18px, 25px);
        font-weight: 500;
        height: 40px;
        display: flex;
        .link {
          color: #FFA119;
          @include ft(14px, 20px);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .actions {
        min-height: 60px;
        .action-btn {
          border-radius: 8px;
          padding-top: 14px;
          padding-bottom: 14px;
          margin-bottom: 10px;
          @include ft(16px, 22px);
          span {
            white-space: nowrap;
          }
        }
        ::v-deep {
          .wx-weapp-item {
            width: 100%;
            height: 55px;
            background: #FFF;
            display: flex;
            align-items: center;
            .link {
              color: #FFA119;
              @include ft(14px, 20px);
              display: flex;
              align-items: center;
            }
          }
        }
        .left {
          margin-right: 13px;
        }
        .right {
        }
      }
    }
  }
}
</style>
